import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { searchProducts } from "../lib/api";
import ProductCard from "../components/ProductCard";

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const q = (searchParams.get("q") || "").trim();
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (q.length < 2) {
      setResults([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    searchProducts(q)
      .then((d) => setResults(d.results || []))
      .catch(() => setResults([]))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <main data-testid="search-page" className="bg-[#0A0A0A] pt-[100px] min-h-screen">
      <section className="border-b border-[#262626] py-10 md:py-16">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-3">✦ Search</div>
          <h1 className="font-serif-display text-4xl md:text-6xl tracking-tight">
            Results for <em className="not-italic gold-text">&ldquo;{q}&rdquo;</em>
          </h1>
          {!loading && (
            <p className="mt-3 font-body text-[13px]" style={{ color: "rgba(255,255,255,0.6)" }}>
              {results.length} {results.length === 1 ? "piece" : "pieces"} found
            </p>
          )}
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-10 pb-24">
        {loading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-[3/4] bg-[#141414] animate-pulse" />
            ))}
          </div>
        ) : results.length === 0 ? (
          <div className="py-16 text-center">
            <div className="font-serif-display italic text-3xl text-[#A3A3A3]">
              No pieces match &ldquo;{q}&rdquo;.
            </div>
            <p className="mt-3 font-body text-sm" style={{ color: "rgba(255,255,255,0.5)" }}>
              Try a different keyword — a category, collection, or colour.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-6 gap-y-12">
            {results.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
        )}
      </section>
    </main>
  );
}
